import { render, staticRenderFns } from "./news-notice-page.vue?vue&type=template&id=bd5a8192&"
import script from "./news-notice-page.vue?vue&type=script&lang=js&"
export * from "./news-notice-page.vue?vue&type=script&lang=js&"
import style0 from "./news-notice-page.vue?vue&type=style&index=0&id=bd5a8192&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports